import styled from "styled-components";
import { lightGray, black, white } from "../utils/color";
import logo from "../utils/img/kuf3.png";
import { Link } from "react-router-dom";

const Nav = styled.nav`
	width: 100%;
	position: fixed;
	bottom: 0;
`;

const ButtonUl = styled.ul`
	list-style-type: None;
	display: flex;
	width: 100%;
	max-width: 600px;
	padding: 0;
	margin: 0;
	box-sizing: border-box;
`;
const ButtionLi = styled.li`
	width: 25%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${lightGray};
	opacity: 0.9;
	height: 75px;
	font-family: "Noto Sans KR", sans-serif;
	font-size: 12px;
	font-weight: ${(props) => `${props.active ? 500 : 300}`};
	border: 1px solid #eee;
`;

const ButtonLink = styled(Link)`
	text-decoration: none;
	color: ${black};
`;

export default function Navigation({ buttonList, active, handleClick }) {
	return (
		<Nav>
			<ButtonUl>
				{buttonList.map((button) => {
					return (
						<ButtionLi
							key={button[0]}
							active={active === button[1]}
							onClick={(e) => handleClick(button[1])}
						>
							<ButtonLink to={button[1] === "" ? "/" : `/${button[1]}`}>
								{button[0]}
							</ButtonLink>
						</ButtionLi>
					);
				})}
			</ButtonUl>
		</Nav>
	);
}
